<template>
  <div class="v-data-items">
    <table v-if="showTable" class="v-data-items__table table">
      <thead>
        <th v-for="field in fields" v-bind:key="field.name">
          {{field.label}}
        </th>
        <th v-if="editMode">&nbsp;</th>
      </thead>
      <tr v-for="(item, itemIndex) in items" v-bind:key="itemIndex">
        <td class="v-data-items__td" v-for="field in fields" v-bind:key="field.name">
          <span class="v-data-items__error" v-for="(message, index) in itemErrorMessages(itemIndex, field.name)" v-bind:key="index">
            {{message}}<br>
          </span>
          <div v-if="editMode">
            <v-number-input v-if="field.type === 'number'" :input-class="'v-data-items__input'" v-model="item[field.name]" :decimal-char="','"></v-number-input>
            <v-currency-input v-if="field.type === 'currency'" :input-class="'v-data-items__input'" v-model="item[field.name]" :decimal-char="','"></v-currency-input>
            <input v-if="field.type === 'text'" class="v-data-items__input" :placeholder="field.placeholder" v-model="item[field.name]" v-on:keydown.enter.prevent>
          </div>
          <div v-if="!editMode">
            <v-number-input v-if="field.type === 'number'" :display-only="true" :input-class="'v-data-items__input'" v-model="item[field.name]" :decimal-char="','"></v-number-input>
            <v-currency-input v-if="field.type === 'currency'" :display-only="true" :input-class="'v-data-items__input'" v-model="item[field.name]" :decimal-char="','"></v-currency-input>
            <span v-if="field.type === 'text'">{{item[field.name]}}</span>
          </div>
        </td>
        <td v-if="editMode" class="v-data-items__remove-td table__td is-align-right is-valign-middle"><button class="btn btn--white v-job-items__remove-button" @click="removeItem(itemIndex)">{{loc('remove')}}</button></td>
      </tr>
      <tr v-if="sumField">
        <td v-for="field in fields" v-bind:key="field.name">
          <div v-if="sumField === field.name">Total: <v-currency-input :display-only="true" :value="totalSum" :decimal-char="','" ></v-currency-input></div>
         <div v-else>&nbsp;</div>
        </td>
        <td v-if="editMode">&nbsp;</td>
      </tr>
    </table>
    <button v-if="editMode" class="v-data-items__add-button btn btn--white" @click="addItem()">{{addBtnText || loc('addRow')}}</button>
  </div>

</template>

<script>
import VCurrencyInput from './v-currency-input.vue';
import VNumberInput from './v-number-input.vue';

export default {
  components: {
    'v-currency-input': VCurrencyInput,
    'v-number-input': VNumberInput
  },
  name: 'VDataItems',
  data: function () {
    return {
      items: [],
      errorData: {},
      patterns: {
        text: '',
        number: '-?[0-9]+[\,.]*[0-9]+'
      }
    }
  },
  props: {
    sumField: String,
    multiplyField: String,
    onChange: Function,
    fields: Array,
    data: Array,
    hideEmpty: Boolean,
    addBtnText: String,
    errors: Object,
    editMode: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    showTable() {
      if(!this.hideEmpty) {
        return true;
      }

      return this.items.length ? true : false;
    },
    totalSum () {
      let sum = 0;
      this.items.forEach(item => {
        const multiplyFieldValue = item[this.multiplyField] || 1;
        const sumFieldValue = (item[this.sumField] || 0) * multiplyFieldValue;
        if(typeof sumFieldValue === 'number') {
          sum += sumFieldValue
        }
      });

      return sum;
    }
  },
  methods: {
    itemErrorMessages(itemIndex, fieldName) {
      const itemData = this.errorData[itemIndex];

      return itemData && itemData[fieldName] && itemData[fieldName].messages || [];
    },
    addItem() {
      const item = {};
      this.fields.forEach(field => {
        item[field.name] = null;
      });

      this.items.push(item);
    },
    removeItem(index) {
      this.items.splice(index, 1);
      if(typeof this.onChange === 'function') {
        this.onChange(this.items);
      }
    },
    update(e) {
      if(typeof this.onChange === 'function') {
        this.onChange(this.items);
      }
    }
  },
  mounted() {
    this.items = this.data || [];
  },
  watch: {
    data() {
      this.items = this.data || [];
    },
    errors() {
      this.errorData = this.errors || {};
    }
  }
}
</script>

<style>

</style>
